import {Injectable,Inject} from 'ng-metadata/core';
import {UserSessionManagerService} from './userSessionManager.service';
import {RestUtils} from '../infra/restUtils.service';
import {getInstitutionCode, getVid,getBackendSystem} from '../appConfig/appConfigForward';
import {BriefResultService} from '../search/briefResult/briefResult.service';
import {FavoritesService} from '../favorites/favorites.service';
import {JwtUtilService} from './jwtUtil.service';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/favorite.interface';
import {StorageUtil} from "../infra/storageUtil.service";
import {SearchHistoryService} from '../favorites/searchHistory/searchHistory.service';
import {PersonalizeResultsButtonService} from "../search/personalization/personalizationButton/personalizeResultsButton.service";
import {TabsAndScopesSelectorService} from '../search/searchBar/tabsAndScopesSelector/tabsAndScopesSelector.service';

@Injectable()
export class UsernamePasswordLoginService {
    private GET_LABELS_URL: string;
    private UPDATE_FAVORITES_URL: string;
    private inst = getInstitutionCode();
    private vid = getVid();
    constructor( private restUtils:RestUtils,
                 private userSessionManagerService:UserSessionManagerService,
                 @Inject('$http') private $http: ng.IHttpService,
                 private searchHistoryService: SearchHistoryService,
                 private jwtUtilService : JwtUtilService,
                 private briefResultService: BriefResultService,
                 @Inject('restBaseURLs') private restBaseURLs,
                 private storageUtil: StorageUtil,
                 private favoritesService : FavoritesService,
                 private personalizeResultsButtonService:PersonalizeResultsButtonService,
                 private tabsAndScopesSelectorService:TabsAndScopesSelectorService,
                 @Inject('$state') private $state: ng.ui.IStateService) {
        this.GET_LABELS_URL= restBaseURLs.favoritesBaseURL;
        this.UPDATE_FAVORITES_URL= restBaseURLs.favoritesBaseURL+ '/';
    }


    async login(username, password, authenticationProfile, targetUrl='') {
        let data = {
            authenticationProfile: authenticationProfile,
            username: username,
            password: password,
            institution: this.inst,
            view: this.vid,
            targetUrl: targetUrl
        };
 		let url = '/primo_library/libweb/primoExploreLogin';
        if(getBackendSystem() === 'suprima'){
        	url = '/primaws/suprimaLogin';
        }
        let loginResponse = await this.restUtils.postToServlet(url, data);
        if(loginResponse.data){

            let id_token = loginResponse.data.jwtData;
            if(!id_token){
                console.log(loginResponse.data)
            }
            await this.userSessionManagerService.login(id_token);
            return loginResponse.data.redirectUrl;
        }
    }

    getFavorites(){
        return this.$http.get(this.GET_LABELS_URL);
    }


    addFavorites(data) {
        let payload= this.briefResultService.buildPaylodOfAddFewRecords(data);
        return this.$http.post(this.UPDATE_FAVORITES_URL, payload);
    }



    copyFavoritesRecordsThatWereSavedForGuest(user){
        if (user != undefined) {
            this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
                if (data.length > 0) {
                    this.addFavorites(data).then(() => {
                        this.getFavoritesFromServer();
                    });
                }
                else {
                    this.getFavoritesFromServer();
                }

            });
        }
        else {
            this.getFavoritesFromServer();
        }

    }

    /*
     replaces the oldSearchHistoryKey with newSearchHistoryKey of the Search History data in localForage
     to keep the Search History items when user login
     not used currently because they are kept anyway.
     */
    changeSearchHistorylocalForageKey(olduser){
        this.searchHistoryService.changeSearchHistorylocalForageKey(olduser);
    }

    combineRecentScopeToSession(olduser){
        if(this.tabsAndScopesSelectorService.isRecentScopesEnabled){
            this.tabsAndScopesSelectorService.combineRecentScopeToSession(olduser);
        }
    }

    getFavoritesFromServer(){
        this.getFavorites().then((response:{data:PrimoResponse.IFavorites}) => {
            let data = response.data;
            let recordsId = data.records.map(function(a) {return a.recordId;});
            this.userSessionManagerService.createOrGetUserArea(this.jwtUtilService.getDecodedToken().user).then((data) => {
                this.userSessionManagerService.area = data;
                if (recordsId.length > 0) {
                    this.userSessionManagerService.extendUserArea(recordsId).then(() => {
                        this.briefResultService.buildJsonOdIdsAndPins();
                        if (this.$state.current.name === STATE_NAMES.FAVORITES) {
                            this.favoritesService.getItemsFromServer();
                        }
                    });
                }
            });
        });

    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/usernamePasswordLogin.service.ts